import UPMultiselectDropdown from './UPMultiselectDropdown';

export default UPMultiselectDropdown;
